"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRequiredForA11y = void 0;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var args = [];
    for (var _i = 5; _i < arguments.length; _i++) {
      args[_i - 5] = arguments[_i];
    }
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;
    if (props[propName] == null) {
      return new Error("The " + location + " `" + propFullNameSafe + "` is required to make " + ("`" + componentNameSafe + "` accessible for users of assistive ") + 'technologies such as screen readers.');
    }
    return validator.apply(void 0, __spreadArrays([props, propName, componentName, location, propFullName], args));
  };
}
exports.isRequiredForA11y = isRequiredForA11y;